import { NavLink, useLocation } from "react-router-dom";
import models from "../../model-declaration";
import { formatUnderscoreToSpace } from "../../utils/text-format";

const Sidebar = () => {
  const loaction = useLocation();

  console.log(models, "models");

  return (
    <aside className="bg-background shadow-custom-soft rounded-lg text-darkText h-full max-h-full overflow-auto p-5">
      <ul>
        <NavLink
          to={`/dashboard`}
          className={`block p-2 hover:bg-gray-200 hover:text-darkText rounded capitalize ${
            loaction.pathname.split("/")[1] === "dashboard"
              ? "bg-primary text-white"
              : ""
          }`}
        >
          Dashboard
        </NavLink>
        <NavLink
          to={`/admin/users/list`}
          className={`block p-2 hover:bg-gray-200 hover:text-darkText rounded capitalize ${
            loaction.pathname.split("/")[1] === "admin"
              ? "bg-primary text-white"
              : ""
          }`}
        >
          Admin Users
        </NavLink>
        <NavLink
          to={`/pos/tables`}
          className={`block p-2 hover:bg-gray-200 hover:text-darkText rounded capitalize ${
            loaction.pathname.split("/")[1] === "admin"
              ? "bg-primary text-white"
              : ""
          }`}
        >
          POS: Tables
        </NavLink>
     
        <NavLink
          to={`/pos/past-orders`}
          className={`block p-2 hover:bg-gray-200 hover:text-darkText rounded capitalize ${
            loaction.pathname.split("/")[1] === "admin"
              ? "bg-primary text-white"
              : ""
          }`}
        >
          POS: Past Orders
        </NavLink>

        {models?.map((model, index) => (
          <NavLink
            key={index}
            to={`/${model?.tableName}/list`}
            className={`block p-2 hover:bg-gray-200 hover:text-darkText rounded capitalize ${
              loaction.pathname.split("/")[1] === model?.tableName
                ? "bg-primary text-white"
                : ""
            }`}
          >
            {formatUnderscoreToSpace(model?.tableName)}
          </NavLink>
        ))}
      </ul>
    </aside>
  );
};

export default Sidebar;
